import psl_ui from '../../libs/psl_ui.js';
import {wait} from '../../libs/psl_polyfills.js';

import audio from '../../components/audio.js';
import instructions from '../../components/instructions/component.js';

import './style.scss';
import template from './template.pst';

import message from '../../components/message/component.js';

psl_ui.templates.add('page_roundabout',template);

const {el,rpoints}=psl_ui.templates.render('page_roundabout');

rpoints.finish.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

rpoints.btn_left.addEventListener('click',()=>{
	_unblur(false);
	if(_compare_angle(rpoints.circle_outer._angle,6) && _compare_angle(rpoints.circle_inner._angle,6)) return;
	_rotate(-10);
});
rpoints.btn_right.addEventListener('click',()=>{
	_unblur(false);
	if(_compare_angle(rpoints.circle_outer._angle,6) && _compare_angle(rpoints.circle_inner._angle,6)) return;
	_rotate(+10);
});
rpoints.continue.addEventListener('click',()=>{
	_finish();
});

const _touch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

([rpoints.circle_outer,rpoints.circle_inner]).forEach(circle=>{
	circle.addEventListener(_touch?'touchstart':'mousedown',e=>{

		if(_compare_angle(rpoints.circle_outer._angle,6) && _compare_angle(rpoints.circle_inner._angle,6)) return;

		document.body.classList.add('rotating');

		_unblur(false);

		instructions.hide();

		const rect = circle.getClientRects()[0];
		const center = {x:rect.left+rect.width/2,y:rect.top+rect.height/2};

		const initial = {x:_touch?e.changedTouches[0].pageX:e.pageX,y:_touch?e.changedTouches[0].pageY:e.pageY};
		const current = {x:_touch?e.changedTouches[0].pageX:e.pageX,y:_touch?e.changedTouches[0].pageY:e.pageY};

		const angle_initial = Math.atan2(initial.x - center.x, - (initial.y - center.y) )*(180 / Math.PI);

		const angle_initial_circle = circle._angle;

		let move = e=>{
			current.x=_touch?e.changedTouches[0].pageX:e.pageX;
			current.y=_touch?e.changedTouches[0].pageY:e.pageY;

			const angle_current = Math.atan2(current.x - center.x, - (current.y - center.y) )*(180 / Math.PI);

			circle._angle=angle_initial_circle+angle_current-angle_initial;

			circle.style.transform=`rotate(${circle._angle}deg)`;
		};

		let up = ()=>{
			window.removeEventListener(_touch?'touchmove':'mousemove',move);
			window.removeEventListener(_touch?'touchend':'mouseup',up);
			let angle = circle._angle-180;
			circle._angle = 180;
			_rotate(angle);
			document.body.classList.remove('rotating');
		}

		window.addEventListener(_touch?'touchmove':'mousemove',move);
		window.addEventListener(_touch?'touchend':'mouseup',up);

	});
});

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/900;
		height=height/1920;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

let _messages=[
	'In a roundabout, all traffic moves in the same direction. That makes serious crashes less likely.',
	'Roundabouts are designed for safety. The tight circle forces drivers to slow down. This leads to fewer crashes than in other intersections.',
];

let _clb;

const _unblur = (v = true)=>{
	rpoints.game_board.classList.remove('blur');
	rpoints.btn_left.removeAttribute('tabindex');
	rpoints.btn_right.removeAttribute('tabindex');

	rpoints.game_board.removeAttribute('aria-hidden');
	rpoints.result.removeAttribute('aria-hidden');

	if(v) rpoints.btn_left.focus();
}

const init = (clb)=>{
	instructions.text='Use the buttons to rotate the rings of the roundabout until all roads are connected.';
	instructions.append(rpoints.container,_unblur);
	rpoints.game_board.classList.add('blur');

	rpoints.game_board.classList.remove('hidden');
	rpoints.finish.classList.add('hidden');
	rpoints.finish.setAttribute('tabindex','-1');
	rpoints.finish.setAttribute('aria-hidden',"true");
	rpoints.continue.classList.add('hidden');
	rpoints.continue.setAttribute('tabindex','-1');
	rpoints.continue.setAttribute('aria-hidden',"true");
	rpoints.finish_screen.classList.add('hidden');

	rpoints.circle_outer._angle = (Math.random()>0.5?1:-1)*(25+155*Math.random());
	rpoints.circle_inner._angle = (Math.random()>0.5?1:-1)*(25+155*Math.random());

	_render_circles(false);

	rpoints.btn_left.setAttribute('tabindex','-1');
	rpoints.btn_right.setAttribute('tabindex','-1');

	_msg_shown = undefined;
	_show_message(0);

	_clb=clb;

	rpoints.result.setAttribute('aria-hidden','true');
	rpoints.game_board.setAttribute('aria-hidden','true');
	rpoints.finish_screen.setAttribute('aria-hidden','true');

}

const _compare_angle = (a,v)=>{
	a=a%360;
	if(a<0) a+=360;

	return a<v || a>360-v;
}

const _rotate=d=>{
	if(_compare_angle(rpoints.circle_outer._angle,6)){
		_show_message(1);
		if(_compare_angle(rpoints.circle_outer._angle,6)){
			rpoints.circle_inner._angle+=d;
			if(_compare_angle(rpoints.circle_inner._angle,6)){
				message.show('Inner ring aligned');
			} else {
				message.show('Not aligned');
			}
		}
	} else {
		rpoints.circle_outer._angle+=d;
		if(_compare_angle(rpoints.circle_outer._angle,6)){
			message.show('Outer ring aligned');
		} else {
			message.show('Not aligned');
		}
	}

	instructions.hide();
	_render_circles();
}

const _render_circles = (sound = true) => {
	if(_compare_angle(rpoints.circle_outer._angle,6)){
		rpoints.circle_outer.style.transform=``;
		rpoints.circle_outer.classList.add('finished');
		rpoints.circle_outer.classList.remove('current');
		rpoints.circle_inner.classList.add('current');
		if(_compare_angle(rpoints.circle_inner._angle,6)){
			rpoints.circle_outer.classList.remove('current');
			rpoints.circle_inner.classList.add('finished');
			rpoints.circle_inner.style.transform=``;
			rpoints.btn_left.classList.add('hidden');
			rpoints.btn_left.setAttribute('tabindex','-1');
			rpoints.btn_right.classList.add('hidden');
			rpoints.btn_right.setAttribute('tabindex','-1');

			rpoints.continue.classList.remove('hidden');
			rpoints.continue.removeAttribute('tabindex');
			rpoints.continue.removeAttribute('aria-hidden');
			instructions.remove();
			if(sound) audio.play('finished');
			return;
		} else {
			rpoints.circle_inner.style.transform=`rotate(${rpoints.circle_inner._angle}deg)`;
		}
	} else {
		rpoints.circle_outer.classList.add('current');
		rpoints.circle_outer.classList.remove('finished');
		rpoints.circle_outer.style.transform=`rotate(${rpoints.circle_outer._angle}deg)`;
		rpoints.circle_inner.style.transform=`rotate(${rpoints.circle_inner._angle}deg)`;
		rpoints.circle_inner.classList.remove('current');
		rpoints.circle_inner.classList.remove('finished');
	}

	rpoints.btn_left.classList.remove('hidden');
	rpoints.btn_right.classList.remove('hidden');
	rpoints.btn_left.removeAttribute('tabindex');
	rpoints.btn_right.removeAttribute('tabindex');
	if(sound) audio.play('ratchet');
}

const _finish = async ()=>{
	rpoints.game_board.classList.add('hidden');
	rpoints.game_board.setAttribute('aria-hidden','true');

	rpoints.result.classList.add('hidden');
	rpoints.result.setAttribute('aria-hidden','true');

	rpoints.continue.classList.add('hidden');
	rpoints.continue.setAttribute('tabindex',-1);
	rpoints.continue.setAttribute('aria-hidden', 'true');
	await wait(250);

	rpoints.finish_screen.classList.remove('hidden');
	rpoints.finish_screen.removeAttribute('aria-hidden');
	rpoints.finish.classList.remove('hidden');
	rpoints.finish.removeAttribute('tabindex');
	rpoints.finish.removeAttribute('aria-hidden');
}

let _msg_shown = undefined;

const _show_message = async (i)=>{

	if(i===_msg_shown) return;

	rpoints.result.removeAttribute('aria-live');
	if(!rpoints.result.classList.contains('hidden')){
		rpoints.result.classList.add('hidden');
		await wait(250);
	}

	rpoints.result_text.innerHTML=_messages[i];
	rpoints.result.classList.remove('hidden');

	_msg_shown=i;
	await wait(250);
	rpoints.result.setAttribute('aria-live','polite');
}

const _ext={
	show:({
		parent,
		clb
	})=>{
		parent.insertBefore(el,parent.firstChild);
		_resize();
		init(clb);
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
